export enum RolesActionTypes {
    TOGGLE_ROLES_MODAL = 'TOGGLE_ROLES_MODAL',
    UPDATE_ROLE_VALUE = 'UPDATE_ROLE_VALUE',
    UPSERT_ROLE_STARTED = 'UPSERT_ROLE_STARTED',
    UPSERT_ROLE_SUCCESSFUL = 'UPSERT_ROLE_SUCCESSFUL',
    UPSERT_ROLE_FAILED = 'UPSERT_ROLE_FAILED',
    FETCH_ALL_ROLES_STARTED = 'FETCH_ALL_ROLES_STARTED',
    FETCH_ALL_ROLES_SUCCESSFUL = 'FETCH_ALL_ROLES_SUCCESSFUL',
    FETCH_ALL_ROLES_FAILED = 'FETCH_ALL_ROLES_FAILED',
    TOGGLE_DELETE_ROLE_CONFIRMATION_MODAL = 'TOGGLE_DELETE_ROLE_CONFIRMATION_MODAL',
    DELETE_ROLE_STARTED = 'DELETE_ROLE_STARTED',
    DELETE_ROLE_SUCCESSFUL = 'DELETE_ROLE_SUCCESSFUL',
    DELETE_ROLE_FAILED = 'DELETE_ROLE_FAILED',
    DUPLICATE_ROLE = 'DUPLICATE_ROLE'
}

export interface Role {
    roleId?: number;
    roleName: string;
    roleDescription: string;
    featurePermissions: number[];
    accessGroupIds: number[];
    userIds: number[];
}

export interface RolesState {
    allRoles: Role[];
    selectedRole: Role;
    savedSelectedRole: Role;
    fetchingRoles: boolean;
    rolesError: string;
    roleModalOpen: boolean;
    deleteConfirmationDialogOpen: boolean;
    deletingRole: boolean;
}
